import { ArrowRight, Phone } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_7a187c08-1566-4a5d-94a6-902036d37fa8/artifacts/oin9oc2t_Untitled%20design%20%2814%29.png";

export default function CTABand({ headline, subtext, ctaText, ctaHref = '#contact', variant = 'dark' }) {
  const scrollTo = (e, id) => {
    e.preventDefault();
    const el = document.querySelector(id);
    if (el) {
      const offset = 80;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  const isDark = variant === 'dark';

  return (
    <section
      className={`py-16 md:py-20 relative overflow-hidden ${
        isDark ? 'bg-poly-blue-dark' : 'bg-poly-blue'
      }`}
      data-testid="cta-band"
    >
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-poly-blue-light/10 rounded-full -translate-y-1/2 translate-x-1/2" />
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-poly-orange/10 rounded-full translate-y-1/2 -translate-x-1/2" />
      {/* Logo watermark */}
      <img src={LOGO_URL} alt="" className="logo-watermark absolute right-10 top-1/2 -translate-y-1/2 w-48 h-48 opacity-[0.06]" aria-hidden="true" />

      <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-12 text-center">
        <h2 className="font-heading font-bold text-2xl sm:text-3xl lg:text-4xl text-white tracking-tight mb-4 reveal">
          {headline}
        </h2>
        <p className="text-white/80 text-base sm:text-lg mb-8 max-w-2xl mx-auto reveal reveal-delay-1">
          {subtext}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center reveal reveal-delay-2">
          <a
            href={ctaHref}
            onClick={(e) => scrollTo(e, ctaHref)}
            className="inline-flex items-center justify-center gap-2 bg-poly-orange hover:bg-orange-600 text-white font-bold px-8 py-4 rounded-full transition-all shadow-lg shadow-orange-500/30 pulse-glow hover:scale-105 active:scale-95"
            data-testid="cta-band-primary"
          >
            {ctaText}
            <ArrowRight className="w-4 h-4" />
          </a>
          <a
            href="tel:8704254295"
            className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 border border-white/30 text-white font-semibold px-8 py-4 rounded-full transition-all hover:scale-105"
            data-testid="cta-band-call"
          >
            <Phone className="w-4 h-4" />
            Call (870) 425-4295
          </a>
        </div>
      </div>
    </section>
  );
}
